import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M18.28 36.304a1 1 0 1 1 1.414 1.414 6.657 6.657 0 0 1-9.414-9.414 1 1 0 1 1 1.414 1.415 4.657 4.657 0 1 0 6.586 6.585"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.695 43.805a2.7 2.7 0 0 0 2.005.002l8.947-3.565a5 5 0 0 0 1.688-1.113l23.818-23.82c2.585-2.59 2.567-6.775-.05-9.385a6.73 6.73 0 0 0-9.467.046L8.891 29.677a5 5 0 0 0-1.105 1.673l-3.59 8.943a2.7 2.7 0 0 0 1.499 3.512m35.043-29.91L16.92 37.717a3 3 0 0 1-1.014.668L6.96 41.95a.7.7 0 0 1-.909-.91l3.591-8.944a3 3 0 0 1 .663-1.003L34.05 7.385a4.727 4.727 0 0 1 6.648-.038c1.83 1.825 1.842 4.742.04 6.549",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M30.987 10.511a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0m11 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M37.28 17.304a1 1 0 1 1 1.414 1.415 6.657 6.657 0 0 1-9.414-9.415 1 1 0 1 1 1.414 1.415 4.657 4.657 0 0 0 6.586 6.585"
    }
  )
);
var SvgEditOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var EditOutlined_default = SvgEditOutlined;

export { EditOutlined_default as default };
